type Params = Record<string, unknown>

export function formatSmokerRateUpsertRule(params: Params): string {
  const increaseRate = params.increaseRate ?? '—'
  const isActive = params.isActive
  const activeLabel =
    isActive === true ? 'Active' : isActive === false ? 'Inactive' : '—'
  return `IncreaseRate: ${increaseRate}, isActive: ${activeLabel}`
}

export const SMOKER_RATE_OVERRIDE_RULE_PATTERN_FORMATTER: Record<
  string,
  (params: Params) => string
> = {
  UPSERT_RULE: formatSmokerRateUpsertRule,
}
